import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  CircularProgress,
  Chip,
  Container,
  Button,
} from "@mui/material";

import { Link } from "react-router-dom";

const noticeCategories = {
  Courts: [
    "Allahabad High Court",
    "Andhra Pradesh High Court - Amravati",
    "Bombay High Court",
    "Chattisgarh High Court",
    "Calcutta High Court",
    "Calcutta High Court (Appellete Side)",
    "Delhi High Court",
    "Delhi High Court - Orders",
    "Gauhati High Court",
    "Gujarat High Court",
    "Himachal Pradesh High Court",
    "Jammu & Kashmir High Court",
    "Jammu & Kashmir High Court - Srinagar Bench",
    "Jharkhand High Court",
    "Karnataka High Court",
    "Kerala High Court",
    "Madhya Pradesh High Court",
    "Madras High Court",
    "Manipur High Court",
    "Meghalaya High Court",
    "Orissa High Court",
    "Patna High Court",
    "Patna High Court - Orders",
    "Punjab-Haryana High Court",
    "Rajasthan High Court - Jaipur",
    "Rajasthan High Court - Jodhpur",
    "Supreme Court of India",
    "Supreme Court - Daily Orders",
    "Sikkim High Court",
    "Tripura High Court",
    "Telangana High Court",
    "Uttarakhand High Court",

    // Add others here...
  ],
  "District Courts": ["Bangalore District Court", "Delhi District Court"],
  Tribunals: [
    "Appellate Tribunal For Electricity",
    "Central Administrative Tribunal",
    "Central Information Commission",
    "Competition Commission of India",
    "Custom, Excise & Service Tax Tribunal",
    "Income Tax Appellate Tribunal",
    "National Consumer Disputes Redressal",
    "National Green Tribunal",
    "National Company Law Appellate Tribunal",
    "Securities Appellate Tribunal",
    "State Consumer Disputes Redressal Commission",
    "Telecom Disputes Settlement Tribunal",
  ],
  Others: ["Lok Sabha Debates"],
};

const apiMap = {
  "Allahabad High Court":
    "https://api.getyoursolution.in/rss-api.php?court=AllahabadHc",
  "Andhra Pradesh High Court - Amravati":
    "https://api.getyoursolution.in/rss-api.php?court=AndhraPradeshHc",
  "Bombay High Court":
    "https://api.getyoursolution.in/rss-api.php?court=BombayHc",
  "Chattisgarh High Court":
    "https://api.getyoursolution.in/rss-api.php?court=ChattisgarhHc",
  "Calcutta High Court":
    "https://api.getyoursolution.in/rss-api.php?court=CalcuttaHc",
  "Calcutta High Court (Appellete Side)":
    "https://api.getyoursolution.in/rss-api.php?court=CalcuttaAsHc",
  "Delhi High Court":
    "https://api.getyoursolution.in/rss-api.php?court=DelhiHc",
  "Delhi High Court - Orders":
    "https://api.getyoursolution.in/rss-api.php?court=DelhiHcO",
  "Gauhati High Court":
    "https://api.getyoursolution.in/rss-api.php?court=GauhatiHc",
  "Gujarat High Court":
    "https://api.getyoursolution.in/rss-api.php?court=GujaratHc",
  "Himachal Pradesh High Court":
    "https://api.getyoursolution.in/rss-api.php?court=HimachalPradeshHc",
  "Jammu & Kashmir High Court":
    "https://api.getyoursolution.in/rss-api.php?court=JammuKashmirHc",
  "Jammu & Kashmir High Court - Srinagar Bench":
    "https://api.getyoursolution.in/rss-api.php?court=JammuKashmirHcSrinagarB",
  "Jharkhand High Court":
    "https://api.getyoursolution.in/rss-api.php?court=JharkhandHc",
  "Karnataka High Court":
    "https://api.getyoursolution.in/rss-api.php?court=KarnatakaHc",
  "Kerala High Court":
    "https://api.getyoursolution.in/rss-api.php?court=KeralaHc",
  "Madhya Pradesh High Court":
    "https://api.getyoursolution.in/rss-api.php?court=MadhyaPradeshHc",
  "Madras High Court":
    "https://api.getyoursolution.in/rss-api.php?court=MadrasHc",
  "Manipur High Court":
    "https://api.getyoursolution.in/rss-api.php?court=ManipurHc",
  "Meghalaya High Court":
    "https://api.getyoursolution.in/rss-api.php?court=MeghalayaHc",
  "Orissa High Court":
    "https://api.getyoursolution.in/rss-api.php?court=OrissaHc",
  "Patna High Court":
    "https://api.getyoursolution.in/rss-api.php?court=PatnaHc",
  "Patna High Court - Orders":
    "https://api.getyoursolution.in/rss-api.php?court=PatnaHcO",
  "Punjab-Haryana High Court":
    "https://api.getyoursolution.in/rss-api.php?court=PunjabHaryanaHc",
  "Rajasthan High Court - Jaipur":
    "https://api.getyoursolution.in/rss-api.php?court=RajasthanJaipurHc",
  "Rajasthan High Court - Jodhpur":
    "https://api.getyoursolution.in/rss-api.php?court=RajasthanJodhpurHc",
  "Supreme Court of India":
    "https://api.getyoursolution.in/rss-api.php?court=SupremeCourtOfIndia",
  "Supreme Court - Daily Orders":
    "https://api.getyoursolution.in/rss-api.php?court=SupremeCourtDailyOrder",
  "Sikkim High Court":
    "https://api.getyoursolution.in/rss-api.php?court=SikkimHc",
  "Tripura High Court":
    "https://api.getyoursolution.in/rss-api.php?court=TripuraHc",
  "Telangana High Court":
    "https://api.getyoursolution.in/rss-api.php?court=TelanganaHc",
  "Uttarakhand High Court":
    "https://api.getyoursolution.in/rss-api.php?court=UttarakhandHc",
  "Bangalore District Court":
    "https://api.getyoursolution.in/rss-api.php?court=BangaloreDistrictCourt",
  "Delhi District Court":
    "https://api.getyoursolution.in/rss-api.php?court=DelhiDistrictCourt",
  "Appellate Tribunal For Electricity":
    "https://api.getyoursolution.in/rss-api.php?court=TribAppellateTribunalForElectricity",
  "Central Administrative Tribunal":
    "https://api.getyoursolution.in/rss-api.php?court=TribCentralAdministrative",
  "Central Information Commission":
    "https://api.getyoursolution.in/rss-api.php?court=TribCentralInformationCommission",
  "Competition Commission of India":
    "https://api.getyoursolution.in/rss-api.php?court=TribCompetitionCommissionofIndia",
  "Custom, Excise & Service Tax Tribunal":
    "https://api.getyoursolution.in/rss-api.php?court=TribCustomExciseServiceTax",
  "Income Tax Appellate Tribunal":
    "https://api.getyoursolution.in/rss-api.php?court=TribIncomeTaxAppellate",
  "National Consumer Disputes Redressal":
    "https://api.getyoursolution.in/rss-api.php?court=TribNationalConsumerDisputesRedressal",
  "National Green Tribunal":
    "https://api.getyoursolution.in/rss-api.php?court=TribNationalGreen",
  "National Company Law Appellate Tribunal":
    "https://api.getyoursolution.in/rss-api.php?court=TribNationalCompanyLawAppellate",
  "Securities Appellate Tribunal":
    "https://api.getyoursolution.in/rss-api.php?court=TribSecuritiesAppellate",
  "State Consumer Disputes Redressal Commission":
    "https://api.getyoursolution.in/rss-api.php?court=TribStateConsumerDisputesRedressalCommission",
  "Telecom Disputes Settlement Tribunal":
    "https://api.getyoursolution.in/rss-api.php?court=TribTelecomDisputesSettlement",
    "Lok Sabha Debates":"https://api.getyoursolution.in/rss-api.php?court=LokSabhaDebates",
  // Add more mappings here
};

const Notices = () => {
  const [selectedCategory, setSelectedCategory] = useState("Allahabad High Court");
  const [noticesData, setNoticesData] = useState([]);
  const [countData, setCountData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  
  useEffect(() => {
    const fetchNotices = async () => {
      setLoading(true);
      const apiUrl = apiMap[selectedCategory];

      if (!apiUrl) {
        setNoticesData([]);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(apiUrl);
        const data = response.data;
        const count = response.count;
        setCountData(count);
        setNoticesData(data["data"]);
      } catch (error) {
        console.error(`Error fetching notices for ${selectedCategory}:`, error);
        setNoticesData([]);
        setCountData(0);
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, [selectedCategory]);

  // Handle mobile drawer toggle
  const toggleDrawer = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  return (
    <>
      <Box 
        sx={{ 
          bgcolor: "primary.main", 
          color: "white", 
          py: { xs: 6, md: 8 },
          backgroundImage: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              maxWidth: "800px",
              mx: "auto",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              className="font-heading"
              sx={{
                fontWeight: 900,
                fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem" },
                letterSpacing: "-0.02em",
                textAlign: "center",
                mb: 2,
              }}
            >
              Latest Court Notices & Judgements
            </Typography>
            <Typography
              variant="h5"
              className="font-sans"
              sx={{
                mb: 4,
                lineHeight: 1.5,
                fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                fontWeight: 400,
                letterSpacing: "0.01em",
                textAlign: "center",
                maxWidth: "700px",
                opacity: 0.9,
              }}
            >
              Stay informed with real-time access to important court updates,
              legal orders, and daily cause lists from the Supreme Court, High Courts, 
              and specialized tribunals — all in one place.
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: { xs: 1, sm: 2 },
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <Button
                component={Link}
                to="/contact"
                variant="contained"
                color="secondary"
                size="large"
                sx={{
                  px: 3,
                  py: 1,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  '&:hover': {
                    boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                  }
                }}
              >
                Schedule a Consultation
              </Button>
              <Button
                component={Link}
                to="/about"
                variant="outlined"
                color="inherit"
                size="large"
                sx={{
                  px: 3,
                  py: 1,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  borderWidth: 2,
                  '&:hover': {
                    borderWidth: 2,
                    bgcolor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                Learn More About Us
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Main content area with responsive layout */}
      <Container maxWidth="xl" sx={{ my: { xs: 2, md: 4 } }}>
        <Box 
          sx={{ 
            display: "flex", 
            flexDirection: { xs: "column", md: "row" },
            position: "relative",
            minHeight: "600px"
          }}
        >
          {/* Mobile view toggle button */}
          <Box 
            sx={{ 
              display: { xs: "flex", md: "none" }, 
              mb: 2,
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: "background.paper",
              p: 2,
              borderRadius: 1,
              boxShadow: 1
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              {selectedCategory}
            </Typography>
            <Button 
              variant="outlined" 
              onClick={toggleDrawer}
              sx={{ textTransform: "none" }}
            >
              Select Court/Tribunal
            </Button>
          </Box>

          {/* Sidebar for desktop / Drawer for mobile */}
          <Box
            sx={{
              width: { md: 300 },
              minWidth: { md: 300 },
              maxWidth: { md: 300 },
              borderRight: { md: "1px solid #e0e0e0" },
              pr: { md: 2 },
              overflowY: "auto",
              height: { md: "calc(100vh - 250px)" },
              position: { xs: "fixed", md: "static" },
              top: 0,
              left: 0,
              zIndex: 1200,
              bgcolor: "background.paper",
              boxShadow: { xs: 3, md: 0 },
              transform: { xs: mobileDrawerOpen ? "translateX(0)" : "translateX(-100%)", md: "translateX(0)" },
              transition: "transform 0.3s ease",
              display: { xs: mobileDrawerOpen ? "block" : "none", md: "block" },
              p: { xs: 2, md: 0 },
              pt: { xs: 2, md: 1 },
              width: { xs: "80%", md: 300 },
            }}
          >
            {/* Close button for mobile */}
            <Box sx={{ display: { xs: "flex", md: "none" }, justifyContent: "flex-end", mb: 2 }}>
              <Button size="small" onClick={toggleDrawer}>Close</Button>
            </Box>
            
            {Object.entries(noticeCategories).map(([category, items]) => (
              <Box key={category} sx={{ mb: 3 }}>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: "bold", 
                    bgcolor: "background.default", 
                    p: 1,
                    borderRadius: 1
                  }}
                >
                  {category}
                </Typography>
                <List dense component="nav">
                  {items.map((item) => (
                    <ListItemButton
                      key={item}
                      selected={selectedCategory === item}
                      onClick={() => {
                        setSelectedCategory(item);
                        if (window.innerWidth < 960) { // Close drawer on mobile after selection
                          setMobileDrawerOpen(false);
                        }
                      }}
                      sx={{
                        borderRadius: 1,
                        mb: 0.5,
                        '&.Mui-selected': {
                          bgcolor: 'primary.light',
                          color: 'primary.contrastText',
                          '&:hover': {
                            bgcolor: 'primary.light',
                          }
                        },
                        '&:hover': {
                          bgcolor: 'action.hover',
                        }
                      }}
                    >
                      <ListItemText 
                        primary={item} 
                        primaryTypographyProps={{
                          fontSize: { xs: '0.875rem', md: '0.9rem' },
                          fontWeight: selectedCategory === item ? 600 : 400
                        }}
                      />
                    </ListItemButton>
                  ))}
                </List>
                <Divider sx={{ my: 1 }} />
              </Box>
            ))}
          </Box>

          {/* Backdrop for mobile drawer */}
          {mobileDrawerOpen && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                bgcolor: "rgba(0,0,0,0.5)",
                zIndex: 1100,
                display: { xs: "block", md: "none" },
              }}
              onClick={toggleDrawer}
            />
          )}

          {/* Notices Content */}
          <Box 
            sx={{ 
              flexGrow: 1,
              pl: { xs: 0, md: 4 },
              pt: { xs: 0, md: 1 },
              overflow: 'hidden',
            }}
          >
            <Typography 
              variant="h4" 
              gutterBottom
              sx={{
                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                fontWeight: 700,
                color: 'primary.dark',
                borderBottom: '2px solid',
                borderColor: 'primary.main',
                pb: 1,
                mb: 3
              }}
            >
              {selectedCategory}
            </Typography>

            {!apiMap[selectedCategory] ? (
              <Box
                sx={{
                  p: 3,
                  bgcolor: 'error.light',
                  color: 'error.dark',
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  textAlign: 'center',
                  minHeight: '200px'
                }}
              >
                <Typography variant="h6" sx={{ mb: 1 }}>
                  No data source configured
                </Typography>
                <Typography variant="body2">
                  No data source configured for {selectedCategory}.
                </Typography>
              </Box>
            ) : loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                <CircularProgress />
              </Box>
            ) : (
              <Box sx={{ maxHeight: { md: 'calc(100vh - 280px)' }, overflowY: 'auto', pr: 1 }}>
                {countData === 0 ? (
                  <Box
                    sx={{
                      p: 4,
                      bgcolor: 'background.default',
                      borderRadius: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      minHeight: '200px',
                      border: '1px dashed',
                      borderColor: 'divider'
                    }}
                  >
                    <Typography>No notices available at this time.</Typography>
                  </Box>
                ) : (
                  noticesData.map((notice, index) => (
                    <Box 
                      key={index} 
                      sx={{ 
                        mb: 3, 
                        p: 2.5, 
                        borderRadius: 2,
                        bgcolor: 'background.paper',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                        border: '1px solid',
                        borderColor: 'divider',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        '&:hover': {
                          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                          transform: 'translateY(-2px)'
                        }
                      }}
                    >
                      <Typography 
                        variant="h6"
                        sx={{
                          fontSize: { xs: '1.1rem', md: '1.25rem' },
                          fontWeight: 600,
                          color: 'primary.dark',
                          mb: 1
                        }}
                      >
                        {notice.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        dangerouslySetInnerHTML={{ __html: notice.description }}
                        sx={{ 
                          mt: 1, 
                          mb: 2,
                          color: 'text.secondary',
                          '& a': {
                            color: 'primary.main',
                            textDecoration: 'none',
                            '&:hover': {
                              textDecoration: 'underline'
                            }
                          }
                        }}
                      />
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Chip
                          label="View Full Details"
                          component="a"
                          href={notice.guid}
                          target="_blank"
                          rel="noopener noreferrer"
                          clickable
                          color="primary"
                          sx={{ 
                            mt: 1,
                            fontWeight: 500,
                            '&:hover': {
                              bgcolor: 'primary.light'
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  ))
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Notices;
